import Urls from "./Urls";
import {AuthManager} from "@cuatroochenta/co-admin-react-library";

export default class TaskImportGTFS {

    private getPostInfo(transportNet: string, file: File) {

        const formData = new FormData();
        formData.append("transport_net_id", transportNet);
        formData.append("gtfs_file", file);

        return {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + AuthManager.getAuthToken()
            },
            body: formData
        }
    }

    public get(transportNet: string, file: File) {
        return fetch(Urls.URL_IMPORT_GTFS, this.getPostInfo(transportNet, file))
            .then(response => response.json())
            .then(data => {return data});
    }
}